import { IconFunctionalInformationCircle16 } from '@cian/ui-kit';
import type { FC, PropsWithChildren } from 'react';
import styles from './AdvancedFilterRowLabelInfo.css';

interface IProps {
  testId: string;

  onClick(): void;
}

export const AdvancedFilterRowLabelInfo: FC<PropsWithChildren<IProps>> = ({ children, testId, onClick }) => {
  return (
    <span data-testid={testId} className={styles['wrapper']}>
      <IconFunctionalInformationCircle16 color="icon-main-default" cursor="pointer" onClick={onClick} />

      {children}
    </span>
  );
};
